let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3rAyF")).then(() => parcelRequire('4T4gn'));